import { Button } from '@kcm/ui'
import { useTranslate } from '@tolgee/react'
import { useSite } from './SiteProvider'

/**
 * The consent prompt (PLAN.md §19).
 *
 * Shown until a decision is made. "Accept all" turns analytics and marketing
 * tags on; "Essential only" leaves them off — strictly necessary cookies run
 * either way, because the funnel cannot function without them.
 */
export function ConsentBanner({
  onDecide,
}: {
  onDecide: (analytics: boolean, marketing: boolean) => void
}) {
  const site = useSite()
  const { t } = useTranslate()

  return (
    <div
      role="dialog"
      aria-label="Cookie consent"
      className="fixed inset-x-0 bottom-0 z-50 border-t border-line bg-white p-4 shadow-lg"
    >
      <div className="mx-auto flex max-w-md flex-col gap-3">
        <p className="text-sm text-muted">
          {t('consent.message')}{' '}
          <a className="underline" href={site.legal.privacyUrl} target="_blank" rel="noreferrer">
            {t('shell.privacyPolicy')}
          </a>
          .
        </p>
        <div className="flex flex-wrap gap-2">
          <Button onClick={() => onDecide(true, true)}>{t('consent.acceptAll')}</Button>
          <Button variant="ghost" onClick={() => onDecide(false, false)}>
            {t('consent.essentialOnly')}
          </Button>
        </div>
      </div>
    </div>
  )
}
